// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__3QF_k","medium":"Button_medium__36X0N","big":"Button_big__1_QLS"};